import {
  DATE_RANGE_PRESET,
  type DateRange,
  type DateRangePreset,
} from "@/utils/date/dateRangeTypes"

/**
 * Widget-specific date range configuration
 * Stored in widget.config.dateRange
 */
export interface WidgetDateRange {
  /** Preset key for predefined ranges */
  preset?: DateRangePreset
  /** Custom date range for fixed dates */
  customRange?: DateRange
  /** For "in the last N days/weeks/months" functionality */
  relativeConfig?: {
    amount: number
    unit: "days" | "weeks" | "months"
  }
  /** Label to display in widget header */
  displayLabel: string
}

/**
 * Default date range for new widgets (1 day - yesterday)
 */
export const DEFAULT_WIDGET_DATE_RANGE: WidgetDateRange = {
  preset: DATE_RANGE_PRESET.LAST_7_DAYS,
  displayLabel: "LAST 7 DAYS",
}
